export const EVENT_AUTH_CLOSE = "Login:Phone:Close";
export const EVENT_OTP_BACK = "Login:OTP:Back";
export const EVENT_PHONE_VIEW = "Login:Phone:View";
export const EVENT_PHONE_CLICK = "Login:Phone:Click";
export const EVENT_PHONE_SUBMIT = "Login:Phone:Submit";
export const EVENT_CAPCTHA_CLICK = "Login:Phone:Captcha:Click";
export const EVENT_OTP_CHECK_ERROR = "Login:OTP:Error";
export const EVENT_OTP_LOGIN = "Login:OTP:Code:Click";
